/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { flowRight, get } from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from '../components/TransactionInformation';
import TaxpayerInformation from '../components/TaxpayerInformation';
import BusinessInformation from '../components/BusinessInformation';
import BusinessActivities from '../components/BusinessActivities';
import FeesInformation from '../components/FeesInformation';
import Requirements from '../components/Requirements';
import Permits from '../components/Permits';
import Location from '../components/Location';
import * as actions from '../actions';
import * as c from '../constant';
import { getInitials } from '../helper';
import useStartAssessment from '../hooks/useStartAssessment';
import useVerifyConfirmation from '../hooks/useVerifyConfirmation';
import useApproveConfirmation from '../hooks/useApproveConfirmation';
import useApproveConfirmationEngr from '../hooks/useApproveConfirmationEngr';
import useApproveConfirmationRenewal from '../hooks/useApproveConfirmationRenewal';
import useRejectConfirmation from '../hooks/useRejectConfirmation';
import useGenerateESOAConfirmation from '../hooks/useGenerateESOAConfirmation';
import useGenerateESOAConfirmationRenewal from '../hooks/useGenerateESOAConfirmationRenewal';
import useRevertApplication from '../hooks/useRevertApplication';
import VerifyReceipt from '../components/VerifyReceipt';
import ViewESOA from '../components/ViewESOA';
import PreviewESOA from '../components/PreviewESOA';
import ViewUaf from '../components/ViewUaf';
import ViewLogs from '../components/ViewLogs';
import GeneratePermit from '../components/GeneratePermit';
import PostBIN from '../components/PostBIN';

import SideScrollingTab from 'modules/common/components/SideScrollingTab';

function Content({
  match,
  getItem,
  adminProfile,
  item,
  isLoading,
  toggleAssessment,
  assisting,
  verifying,
  approving,
  approvingEngr,
  approvingRenewal,
  rejecting,
  generatingESOA,
  generateESOA,
  generatingESOARenewal,
  generateESOARenewal,
  revertApplication,
  revertingApplication,
  list,
  getListGroup,
  listGroup,
  refreshList,
  verifyPreviewESOA,
  verifyingPreview,
}) {
  const permissions = getJson('permissions');
  const setModal = useContext(ModalContext);

  const isStartAssessment = get(item, 'attributes.is_start_assessment');
  const isPermitGenerated =
    get(
      item,
      'included.ebplsApplication.attributes.sanitary_permit_generated_at'
    ) ||
    get(
      item,
      'included.ebplsApplication.attributes.business_permit_generated_at'
    );
  const allPermitsGenerated =
    get(
      item,
      'included.ebplsApplication.attributes.sanitary_permit_generated_at'
    ) &&
    get(
      item,
      'included.ebplsApplication.attributes.business_permit_generated_at'
    );
  const isBPLO = _.isEmpty(get(item, 'attributes.verified_at'));
  const isPlanning =
    _.isEmpty(get(item, 'attributes.planning_assessed_at')) && !isBPLO;
  const isEngineering =
    _.isEmpty(get(item, 'attributes.engineering_assessed_at')) &&
    !isPlanning &&
    !isBPLO;
  const startAssessment = useStartAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.ebplsApplication.attributes.status'),
    () => {
      toggleAssessment(get(item, 'id'), {}, () => {
        refreshList(get(item, 'id'));
        getItem(get(item, 'id'));
      });
    }
  );

  const verifyConfirmation = useVerifyConfirmation(
    verifying,
    isStartAssessment,
    refreshList,
    get(item, 'attributes.transaction_status'),
    get(item, 'id'),
    get(item, 'included.ebplsApplication.attributes.tracking_number'),
    get(item, 'attributes.transaction_type')
  );

  const approveConfirmation = useApproveConfirmation(
    approving,
    isStartAssessment,
    refreshList,
    get(item, 'attributes.transaction_status'),
    get(item, 'id'),
    get(item, 'included.ebplsApplication.attributes.tracking_number')
  );

  const approveConfirmationEngr = useApproveConfirmationEngr(
    approvingEngr,
    isStartAssessment,
    refreshList,
    get(item, 'attributes.transaction_status'),
    get(item, 'id'),
    get(item, 'included.ebplsApplication.attributes.tracking_number')
  );

  const approveConfirmationRenewal = useApproveConfirmationRenewal(
    approvingRenewal,
    isStartAssessment,
    refreshList,
    get(item, 'attributes.transaction_status'),
    get(item, 'id')
  );

  const rejectConfirmation = useRejectConfirmation(
    rejecting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.ebplsApplication.attributes.status'),
    get(item, 'id')
  );

  const revertApplicationConfirmation = useRevertApplication(
    revertingApplication,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.ebplsApplication.attributes.status'),
    match.params.transaction_type,
    () =>
      revertApplication(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      })
  );
  const generateESOAConfirmation = useGenerateESOAConfirmation(
    generatingESOA,
    get(item, 'attributes.transaction_status'),
    get(item, 'attributes.status'),
    get(item, 'included.ebplsApplication.attributes.status'),
    get(item, 'included.ebplsApplication.attributes.soa_generated_at'),
    () =>
      generateESOA(get(item, 'id'), {}, (response) => {
        getItem(get(item, 'id'));
        setModal({
          isOpen: true,
          content: <ViewESOA data={item} generateAmount={response} />,
          title: 'View e-SOA',
          modalSize: 'modal-xl',
        });
      })
  );

  const generateESOAConfirmationRenewal = useGenerateESOAConfirmationRenewal(
    generatingESOARenewal,
    get(item, 'attributes.transaction_status'),
    get(item, 'attributes.status'),
    get(item, 'included.ebplsApplication.attributes.status'),
    get(item, 'included.ebplsApplication.attributes.soa_generated_at'),
    () => {
      const args = {
        year: get(item, 'included.ebplsApplication.attributes.year') || '',
        qtr: get(item, 'included.ebplsApplication.attributes.soa_qtr') || '',
        group_id: get(item, 'attributes.group_id') || '',
      };
      generateESOARenewal(get(item, 'id'), args, (response) => {
        getItem(get(item, 'id'));
        setModal({
          isOpen: true,
          content: <ViewESOA data={item} generateAmount={response} />,
          title: 'View e-SOA',
          modalSize: 'modal-xl',
        });
      });
    }
  );

  useEffect(() => {
    if (match.params.ebpls_id && !_.isEmpty(list)) {
      getItem(match.params.ebpls_id, ({ data }) => {
        getListGroup({
          module_type: 'EBPLS',
          q: '',
          sort_by: 'asc',
          transaction_status: '',
          year: '',
          transaction_type: 'RENEWAL',
          latest_group_id: 0,
          group_id: +_.get(data, 'attributes.group_id'),
        });
      });
    }
  }, [match.params.ebpls_id, list]);

  const checkAssessor = () => {
    if (_.get(item, 'attributes.is_start_assessment') > 0) {
      return (
        +_.get(adminProfile, 'id') === _.get(item, 'attributes.start_assess_by')
      );
    }
    if (_.get(item, 'attributes.is_start_assessment') === 0) return true;
  };

  const handleViewESOA = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewESOA data={item} />,
      title: `View e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  const handlePreviewESOA = (e) => {
    e.preventDefault();
    verifyPreviewESOA(item.id, () => {
      setModal({
        isOpen: true,
        content: <PreviewESOA data={item} />,
        title: `View e-SOA`,
        modalSize: 'modal-xl',
      });
    });
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <VerifyReceipt transactionInfo={item} id={item.id} />,
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleViewUaf = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewUaf data={item} />,
      title: `Unified Application Form`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewLogs = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewLogs id={item.id} />,
      title: `Audit Logs`,
      modalSize: 'modal-xl',
    });
  };

  const handleGeneratePermit = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <GeneratePermit
          id={item.id}
          sanitaryPermit={get(
            item,
            'included.ebplsApplication.attributes.sanitary_permit_generated_at'
          )}
          businessPermit={get(
            item,
            'included.ebplsApplication.attributes.business_permit_generated_at'
          )}
        />
      ),
      title: `Generate Permits`,
      modalSize: 'modal-md',
    });
  };

  const handlePostBIN = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <PostBIN
          id={item.id}
          status={get(item, 'attributes.transaction_status')}
        />
      ),
      title: `Post BIN`,
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="card-section-content container-fluid">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="p-3">
        <div className="d-flex mb-3">
          <div className="mr-2">
            <div className="d-flex round-image justify-content-center">
              {get(item, 'included.taxPayer.attributes.photo') && (
                <img
                  className="round-image"
                  src={get(item, 'included.taxPayer.attributes.photo')}
                  alt="Profile"
                />
              )}
              {!get(item, 'included.taxPayer.attributes.photo') && (
                <h3 className="d-flex align-items-center initials mb-0">
                  {getInitials(get(item, 'attributes.name'))}
                </h3>
              )}
            </div>
          </div>
          <div className="d-flex flex-column align-items-start flex-grow-1">
            <h1>
              {get(item, 'included.ebplsApplication.attributes.business_name')}
            </h1>
            <h4 className="text-primary">{get(item, 'attributes.name')}</h4>
          </div>
        </div>
      </div>
      <div className="row justify-content-end mb-1 mr-1">
        {Acl(permissions, ['EBPLS APPLICATION - REVERT']) &&
          revertApplicationConfirmation.component}
        {Acl(permissions, ['EBPLS BPLO - GENERATE ESOA']) &&
          checkAssessor() &&
          match.params.transaction_type === 'new' &&
          generateESOAConfirmation.component}
        {Acl(permissions, ['EBPLS BPLO - GENERATE ESOA']) &&
          checkAssessor() &&
          match.params.transaction_type === 'renewal' &&
          generateESOAConfirmationRenewal.component}
        {['ASSESSED BY BPLO'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
          !get(item, 'included.ebplsApplication.attributes.soa_generated_at') &&
          Acl(permissions, ['VIEW EBPLS ESOA']) && (
            <div className="mx-2 mb-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handlePreviewESOA}
                disabled={verifyingPreview}
              >
                {verifyingPreview && (
                  <i className="fas fa-spinner fa-spin fa-lg" />
                )}
                &nbsp;&nbsp;Preview eSOA
              </button>
            </div>
          )}
        {['ASSESSED BY BPLO'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
          get(item, 'included.ebplsApplication.attributes.soa_generated_at') &&
          Acl(permissions, ['EBPLS BPLO - VIEW ESOA']) && (
            <div className="mx-2 mb-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewESOA}
              >
                View eSOA
              </button>
            </div>
          )}
      </div>
      <div className="row justify-content-end mb-1 mr-1">
        {Acl(permissions, [
          'EBPLS BPLO - START VERIFY',
          'EBPLS PLANNING DEPARTMENT - START ASSESSMENT',
          'EBPLS ENGINEERING DEPARTMENT - START ASSESSMENT',
        ]) &&
          (match.params.transaction_type === 'new' ||
            (match.params.transaction_type === 'renewal' &&
              ['PENDING', 'ONGOING'].indexOf(
                get(item, 'attributes.transaction_status')
              ) > -1)) &&
          checkAssessor() &&
          startAssessment.component}
        {Acl(permissions, ['EBPLS BPLO - VERIFY']) &&
          match.params.transaction_type === 'new' &&
          isBPLO &&
          isStartAssessment === 1 &&
          verifyConfirmation.component}
        {Acl(permissions, ['EBPLS PLANNING DEPARTMENT - APPROVE']) &&
          match.params.transaction_type === 'new' &&
          isPlanning &&
          isStartAssessment === 1 &&
          approveConfirmation.component}
        {Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - APPROVE']) &&
          match.params.transaction_type === 'new' &&
          isEngineering &&
          isStartAssessment === 1 &&
          approveConfirmationEngr.component}
        {Acl(permissions, ['EBPLS BPLO - APPROVE RENEWAL']) &&
          match.params.transaction_type === 'renewal' &&
          isStartAssessment === 1 &&
          approveConfirmationRenewal.component}
        {Acl(permissions, ['EBPLS BPLO - REJECT']) &&
          isBPLO &&
          isStartAssessment === 1 &&
          rejectConfirmation.component}
        {Acl(permissions, ['EBPLS PLANNING DEPARTMENT - REJECT']) &&
          match.params.transaction_type === 'new' &&
          isPlanning &&
          isStartAssessment === 1 &&
          rejectConfirmation.component}
        {Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - REJECT']) &&
          match.params.transaction_type === 'new' &&
          isEngineering &&
          isStartAssessment === 1 &&
          rejectConfirmation.component}
        {Acl(permissions, ['VIEW EBPLS']) &&
          ['ASSESSED BY BPLO'].indexOf(
            _.get(item, 'attributes.transaction_status')
          ) > -1 && (
            <button
              onClick={handleVerifyReceipt}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2 mb-2 font-weight-bold"
              type="button"
            >
              Assess Payment Receipt
            </button>
          )}
        {Acl(permissions, ['EBPLS POST BIN']) &&
        ((['VERIFIED'].indexOf(_.get(item, 'attributes.transaction_status')) >
          -1 &&
          match.params.transaction_type === 'renewal') ||
          ([
            'FOR ACCOUNT CREATION',
            'ASSESSED BY ENGINEERING DEPARTMENT',
          ].indexOf(_.get(item, 'attributes.transaction_status')) > -1 &&
            match.params.transaction_type === 'new')) ? (
          <div className="mx-2">
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 font-weight-bold"
              onClick={handlePostBIN}
            >
              Post BIN
            </button>
          </div>
        ) : (
          ''
        )}
        {Acl(permissions, ['VIEW EBPLS UAF']) && (
          <div className="mx-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 font-weight-bold"
              type="button"
              onClick={handleViewUaf}
            >
              View UAF
            </button>
          </div>
        )}
        {Acl(permissions, ['VIEW EBPLS LOGS']) && (
          <div className="mx-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 font-weight-bold"
              type="button"
              onClick={handleViewLogs}
            >
              View Logs
            </button>
          </div>
        )}
        {Acl(permissions, ['EBPLS BPLO - GENERATE PERMIT']) &&
        !allPermitsGenerated &&
        get(item, 'attributes.transaction_status') === 'PAID' &&
        get(item, 'included.ebplsApplication.attributes.soa_generated_at') &&
        get(item, 'attributes.paid_at') ? (
          <div className="mx-2">
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 font-weight-bold"
              onClick={handleGeneratePermit}
            >
              Generate Permit
            </button>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="p-3">
        <Tabs>
          <SideScrollingTab dragToScroll>
            <TabList>
              <Tab>Transaction</Tab>
              <Tab>Business</Tab>
              <Tab>Account</Tab>
              <Tab>Activities</Tab>
              <Tab>Location</Tab>
              <Tab>Requirements</Tab>
              {isPermitGenerated && <Tab>Permit</Tab>}
              {get(item, 'included.ebplsApplicationFees', []).length > 0 && (
                <Tab>Fees</Tab>
              )}
            </TabList>
          </SideScrollingTab>
          <TabPanel>
            <TransactionInformation
              data={item}
              transactionList={listGroup}
              viewEsoa={handleViewESOA}
              generatePermit={handleGeneratePermit}
            />
          </TabPanel>
          <TabPanel>
            <BusinessInformation data={get(item, 'included')} remarks={item} />
          </TabPanel>
          <TabPanel>
            <TaxpayerInformation data={get(item, 'included')} />
          </TabPanel>
          <TabPanel>
            <BusinessActivities
              data={get(item, 'included.ebplsBusinessActivities')}
              businessInformation={item}
              isStartAssessment={isStartAssessment}
              checkAssessor={checkAssessor}
            />
          </TabPanel>
          <TabPanel>
            <Location
              pinLocation={
                get(
                  item,
                  'included.ebplsBusiness.attributes.business_address.pinned_geolocation'
                ) || ''
              }
              data={get(
                item,
                'included.ebplsBusiness.attributes.business_address'
              )}
            />
          </TabPanel>
          <TabPanel>
            <Requirements
              data={get(item, 'included.ebplsApplicationRequirements')}
            />
          </TabPanel>
          {isPermitGenerated && (
            <TabPanel>
              <Permits data={item} />
            </TabPanel>
          )}
          {get(item, 'included.ebplsApplicationFees', []).length > 0 && (
            <TabPanel>
              <FeesInformation
                data={get(item, 'included.ebplsApplicationFees')}
              />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = ({ api }) => {
  return {
    listGroup: get(api, `${c.LIST_GROUP}.list`) || [],
    adminProfile: getJson('profile'),
    item: get(api, `${c.ITEM}.item`) || {},
    isLoading: api.loading.indexOf(c.ITEM) > -1,
    verifying: api.loading.indexOf(c.VERIFY) > -1,
    approving: api.loading.indexOf(c.APPROVE) > -1,
    approvingEngr: api.loading.indexOf(c.APPROVE_ENGR) > -1,
    approvingRenewal: api.loading.indexOf(c.APPROVE_RENEWAL) > -1,
    verifyingPreview: api.loading.indexOf(c.VERIFY_PREVIEW_SOA) > -1,
    rejecting: api.loading.indexOf(c.REJECT) > -1,
    assisting: api.loading.indexOf(c.TOGGLE_ASSESSMENT) > -1,
    generatingESOA: api.loading.indexOf(c.GENERATE_ESOA) > -1,
    generatingESOARenewal: api.loading.indexOf(c.GENERATE_ESOA_RENEWAL) > -1,
    revertingApplication: api.loading.indexOf(c.REVERT_APPLICATION) > -1,
  };
};

const enhance = flowRight([withRouter, connect(mapStateToProps, actions)]);

Content.propTypes = {
  adminProfile: PropTypes.instanceOf(Object).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  getListGroup: PropTypes.instanceOf(Function).isRequired,
  listGroup: PropTypes.instanceOf(Array).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  toggleAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  verifying: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  approvingEngr: PropTypes.bool.isRequired,
  approvingRenewal: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  assisting: PropTypes.bool.isRequired,
  generatingESOA: PropTypes.bool.isRequired,
  generateESOA: PropTypes.instanceOf(Function).isRequired,
  generatingESOARenewal: PropTypes.bool.isRequired,
  generateESOARenewal: PropTypes.instanceOf(Function).isRequired,
  revertingApplication: PropTypes.bool.isRequired,
  revertApplication: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  verifyPreviewESOA: PropTypes.instanceOf(Function).isRequired,
  verifyingPreview: PropTypes.bool.isRequired,
};

export default enhance(Content);
